export const API_URL = 'https://api.coingecko.com/api/v3/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 15;
export const MODAL_CLOSE_SEC = 2;
